import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/contexts/AuthContext';
import { createApiClient } from '@/shared/api/apiClient';
import type { components } from '@/shared/api/openapi';

export interface UseAllocationGroupUserMembershipOptions {
  organizationId: number;
  groupId: number;
  userIds: string[];
  enabled?: boolean;
}

type AllocationGroupUserMembershipResult = components['schemas']['CheckAllocationGroupUserMembershipEndpoint_Response'];

export function useAllocationGroupUserMembership({
  organizationId,
  groupId,
  userIds,
  enabled = true,
}: UseAllocationGroupUserMembershipOptions) {
  const { getAccessToken } = useAuth();

  return useQuery({
    queryKey: ['allocation-group-user-membership', organizationId, groupId, userIds],
    queryFn: async ({ signal }) => {
      const client = createApiClient(getAccessToken, {
        cache: 'no-store',
        signal,
      });

      const { data, error } = await client.POST('/api/organizations/{organizationId}/allocation-groups/{groupId}/users/check', {
        params: {
          path: { organizationId, groupId },
        },
        body: { userIds },
      });

      if (error) {
        throw error;
      }

      return (data ?? []) as AllocationGroupUserMembershipResult[];
    },
    enabled: enabled && userIds.length > 0,
    staleTime: 10000,
  });
}
